<template>
    <div>
        <b-form-group>
            <label class="typo__label">{{ $t('forms.downtimetype') }}</label>
            <multiselect v-model="resetCheckTimeOptionSelected"
                         track-by="value"
                         :close-on-select="true"
                         :show-labels="false"
                         label="text"
                         placeholder="Select one"
                         :options="resetCheckTimeOptions"
                         :searchable="false"
                         :allow-empty="false">
            </multiselect>
        </b-form-group>
        <br>
        <b-button variant="success" class="w-100" v-on:click="sendResetCheckTime">{{
                $t('forms.send-command')
            }}
        </b-button>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {useToast} from "vue-toastification";

export default {
    name: "HostResetCheckTime",
    components: {Multiselect},
    data(){
        return {
            resetCheckTimeOptionSelected: {
                value: 'hostOnly',
                text: this.$t('hosts.individual')
            },
            resetCheckTimeOptions: [
                {
                    value: 'hostOnly',
                    text: this.$t('hosts.individual')
                },
                {
                    value: 'hostAndServices',
                    text: this.$t('hosts.including-services')
                }
            ],
        }
    },
    props: ['hostuuid', 'satelliteId'],
    methods: {
        sendResetCheckTime: function(){
            let externalCommand = [
                {
                  /*  command: 'SCHEDULE_FORCED_HOST_CHECK',
                    hostUuid: this.getUuid */

                    command: 'rescheduleHost',
                    hostUuid: this.getUuid,
                    satelliteId: this.satelliteId,
                    type: this.resetCheckTimeOptionSelected.value
                }
            ];

            axios.post('/hosts/external_commands.json', externalCommand)
                .then(response => {
                    useToast().success(this.$t('Command successfully sent'), {
                        timeout: 7000
                    });
                    this.$emit('refresh', 'hostScheduleResetCheckTime')
                })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                });
        },
    },
    mounted(){

    },
    computed: {
        getUuid: function(){
            return this.hostuuid;
        }
    }
}
</script>

<style scoped>

</style>
